'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

require('./FormInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


var INPUT_PROPS = [
// HTML attributes
'placeholder', 'type', 'value', 'defaultValue', 'disabled', 'autoComplete', 'maxLength',
// Event listeners
'onBlur', 'onChange', 'onFocus'];

var FormInput = function (_React$Component) {
    _inherits(FormInput, _React$Component);

    function FormInput(props) {
        _classCallCheck(this, FormInput);

        var _this = _possibleConstructorReturn(this, (FormInput.__proto__ || Object.getPrototypeOf(FormInput)).call(this, props));

        _this.focus = _this.focus.bind(_this);
        return _this;
    }

    _createClass(FormInput, [{
        key: 'focus',
        value: function focus() {
            this.input.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                name = _props.name,
                type = _props.type,
                fields = _props.fields,
                onChange = _props.onChange,
                sanitisedErrors = _props.sanitisedErrors,
                className = _props.className,
                noName = _props.noName,
                valueFormatter = _props.valueFormatter;

            var field = fields[name];

            var isError = sanitisedErrors[name] && sanitisedErrors[name].showError;

            return _react2.default.createElement('input', _extends({ id: name
            }, (0, _lodash.pick)(this.props, INPUT_PROPS), (0, _lodash.pick)(field, INPUT_PROPS), {
                value: valueFormatter ? valueFormatter(field.value) : field.value,
                ref: function ref(c) {
                    _this2.input = c;
                },
                name: noName ? undefined : name,
                type: type,
                onChange: onChange(name),
                className: (0, _classnames2.default)('FormInput', className, { error: isError }) }));
        }
    }]);

    return FormInput;
}(_react2.default.Component);

FormInput.propTypes = {
    name: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    fields: _propTypes2.default.object.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    sanitisedErrors: _propTypes2.default.object,
    className: _propTypes2.default.string,
    noName: _propTypes2.default.bool,
    valueFormatter: _propTypes2.default.func
};

exports.default = FormInput;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/fields/FormInput.js
// module id = 96
// module chunks = 0